(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["posiosa-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('posiosa-faq')) {
    customElements.define('posiosa-faq', class extends HTMLElement {
      connectedCallback() {
        this._abort?.abort(); this._abort = new AbortController();
        this.addEventListener('toggle', event => {
          const current = event.target;
          if (this.dataset.single !== 'true' || !current.matches('details.pfq-item') || !current.open) return;
          this.querySelectorAll('details.pfq-item').forEach(item => { if (item !== current) item.open = false; });
        }, { capture:true, signal:this._abort.signal });
        this.addEventListener('shopify:block:select', event => {
          const item = Array.from(this.querySelectorAll('[data-faq-block]')).find(el => el.dataset.faqBlock === event.detail?.blockId);
          if (item) item.open = true;
        }, { signal:this._abort.signal });
      }
      disconnectedCallback() { this._abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["posiosa-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('posiosa-footer-top')){customElements.define('posiosa-footer-top',class extends HTMLElement{connectedCallback(){this.onclick=()=>window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}disconnectedCallback(){this.onclick=null;}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["posiosa-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('posiosa-product-details')) {
    customElements.define('posiosa-product-details', class extends HTMLElement {
      connectedCallback() {
        this._abort?.abort();
        this._abort = new AbortController();
        this._panels = Array.from(this.querySelectorAll('[data-pdx-panel]'));
        this._buttons = Array.from(this.querySelectorAll('[data-pdx-select]'));
        const options = { signal: this._abort.signal };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-pdx-select]');
          if (button && button.closest('posiosa-product-details') === this) this.select(button.dataset.pdxSelect, true);
        }, options);
        this.addEventListener('shopify:block:select', event => this.select(event.detail.blockId, false), options);
        this.querySelectorAll('.pdx-detail-image').forEach(image => image.addEventListener('load', () => this.fitImage(), options));
        this._resize?.disconnect();
        this._resize = new ResizeObserver(() => this.fitImage());
        this._resize.observe(this.querySelector('.pdx-detail-column'));
        this.setAttribute('data-ready', '');
        this.select(this._active || this._panels[0]?.dataset.pdxPanel, false);
      }
      disconnectedCallback() {
        this._abort?.abort(); this._resize?.disconnect(); this._animation?.cancel();
      }
      select(id, animate) {
        const selected = this._panels.find(panel => panel.dataset.pdxPanel === id) || this._panels[0];
        if (!selected) return;
        this._active = selected.dataset.pdxPanel;
        this._panels.forEach(panel => { panel.hidden = panel !== selected; });
        this._buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pdxSelect === this._active)));
        this.fitImage();
        this._animation?.cancel();
        if (animate && this.dataset.motion === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this._animation = selected.querySelector('.pdx-detail-frame').animate([
            { opacity: 0.4, transform: 'scale(.98)' }, { opacity: 1, transform: 'scale(1)' }
          ], { duration: 420, easing: 'cubic-bezier(.2,.65,.2,1)' });
        }
      }
      fitImage() {
        const panel = this._panels.find(item => item.dataset.pdxPanel === this._active);
        const frame = panel?.querySelector('.pdx-detail-frame');
        const image = frame?.querySelector('img');
        if (!image?.naturalWidth || !frame.clientWidth) return;
        const width = frame.clientWidth, height = frame.clientHeight;
        const zoom = Math.max(1, Number(frame.dataset.zoom || 100) / 100);
        const scale = Math.max(width / image.naturalWidth, height / image.naturalHeight) * zoom;
        const imageWidth = image.naturalWidth * scale, imageHeight = image.naturalHeight * scale;
        const x = Math.max(width - imageWidth, Math.min(0, width / 2 - imageWidth * Number(frame.dataset.x || 50) / 100));
        const y = Math.max(height - imageHeight, Math.min(0, height / 2 - imageHeight * Number(frame.dataset.y || 50) / 100));
        image.style.width = imageWidth + 'px'; image.style.height = imageHeight + 'px';
        image.style.transform = `translate(${x}px, ${y}px)`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
